import React from "react";
import styled from "styled-components";
import { OffScreenComponent } from "../../../ui/components/mixins";
import PropTypes from "prop-types";

const Styled = {
  Figure: styled.figure`
    ${props => props.extraStyles}
  `,
  NoFigure: styled.div`
    ${props => props.extraStyles}
  `,
  Image: styled.img`
    ${props => props.extraStyles}
  `
};

/**
 * title/caption/alt are not handled completely consistently in the figures panel, but let's
 * make sure we're doing something consistent here
 * Intentionally unstyled! Caller can assume <some-block-level-wrapper><img /></some-block-level-wrapper>
 * and provide styling accordingly
 */
export default function FigureOrImage({
  title,
  caption,
  alt,
  src,
  src2x,
  figureStyles,
  imageStyles,
  forceFigure
}) {
  const useFigure = forceFigure || title || caption;
  const Container = useFigure ? Styled.Figure : Styled.NoFigure;
  const altFallback = useFigure
    ? ""
    : i18n.t("flashcards.images.description-unavailable");

  return (
    <Container extraStyles={figureStyles}>
      <Styled.Image
        src={src}
        srcSet={src2x && `${src2x} 2x`}
        alt={alt || altFallback}
        extraStyles={imageStyles}
      />
      {useFigure && (
        <figcaption>
          <OffScreenComponent>
            {title && <p>{title}</p>}
            {caption && <p>{caption}</p>}
            {!title &&
              !caption &&
              i18n.t("flashcards.images.description-unavailable")}
          </OffScreenComponent>
        </figcaption>
      )}
    </Container>
  );
}

FigureOrImage.propTypes = {
  title: PropTypes.string,
  caption: PropTypes.string,
  alt: PropTypes.string,
  src: PropTypes.string,
  src2x: PropTypes.string,
  forceFigure: PropTypes.bool,
  // styled-components css blobs
  figureStyles: PropTypes.arrayOf(PropTypes.string),
  imageStyles: PropTypes.arrayOf(PropTypes.string)
};
